module.exports = "../../map/Tokyo/map/agriculture/Tokyo_AgricultureTankan_CMIP5RCP85_MIROC_No_R2081_2100.png";